const seoLocations = [
  "main/seo",
  "main/container/seo",
  "main/top-container/seo",
  "main/bottom-container/seo"
];
function getPageSeo(brPage) {
  if (!brPage) {
    return void 0;
  }
  let seo;
  for (const path of seoLocations) {
    const componentNames = path.split("/");
    const comp = brPage.getComponent(...componentNames);
    if (comp?.getModels()) {
      seo = comp.getModels().seoData;
      break;
    }
  }
  return seo;
}
export {
  getPageSeo
};
//# sourceMappingURL=get-page-seo.js.map
